import React from 'react';
import { ArrowLeft, Phone, Shield, UserPlus } from 'lucide-react';
import { AISummaryCard } from '../components/ui/AISummaryCard';
import { AudioPlayer } from '../components/ui/AudioPlayer';
import { useTheme } from '../contexts/ThemeContext';
interface CallDetailScreenProps {
  onBack: () => void;
}
export function CallDetailScreen({
  onBack
}: CallDetailScreenProps) {
  const {
    isLight
  } = useTheme();
  return <div className="h-full flex flex-col relative" data-id="element-1350" data-mp="p4fhu7vh28bl">
      <div className={`p-4 border-b flex items-center gap-3 sticky top-0 backdrop-blur-2xl z-10 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/50' : 'bg-dark/80 border-white/5'}`} data-id="element-1351" data-mp="p1jkaknjdlno">
        <button onClick={onBack} className={`p-2 -ml-2 rounded-full border transition-colors ${isLight ? 'text-slate-500 hover:text-slate-900 bg-white/60 backdrop-blur-md border-slate-200' : 'text-zinc-400 hover:text-white bg-white/5 backdrop-blur-md border-white/10'}`} data-id="element-1352" data-mp="k41ayt5lx4f5">
          <ArrowLeft className="w-5 h-5" data-id="element-1353" data-mp="2nnyy5lq85vgj" />
        </button>
        <span className={`font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-1354" data-mp="2nql6hnkxwezt">
          Call Details
        </span>
      </div>

      <div className="flex-1 overflow-y-auto p-6 space-y-6 pb-24" data-id="element-1355" data-mp="2wpf85sd4nvk8">
        <div className="flex flex-col items-center text-center mb-6" data-id="element-1356" data-mp="2rq2eannu9o85">
          <div className={`w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold mb-3 border transition-colors ${isLight ? 'bg-purple-100 text-purple-700 border-purple-200' : 'bg-white/10 backdrop-blur-sm text-white border-white/10'}`} data-id="element-1357" data-mp="2ror9ckinqafg">
            SM
          </div>
          <h2 className={`text-xl font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-1358" data-mp="3fhhiyn338hmk">
            Sarah Miller
          </h2>
          <p className={isLight ? 'text-slate-500' : 'text-zinc-400'} data-id="element-1359" data-mp="3pevymkh6t2dt">
            +1 (555) 987-6543
          </p>
          <div className={`flex items-center gap-2 mt-2 text-sm ${isLight ? 'text-slate-400' : 'text-zinc-500'}`} data-id="element-1360" data-mp="3kgax8hq78cns">
            <span data-id="element-1361" data-mp="2m2wzfg99ejix">Feb 10, 2:30 PM</span>
            <span data-id="element-1362" data-mp="2m3ynclbdj0i2">•</span>
            <span data-id="element-1363" data-mp="2m36q7624oupo">Incoming Call</span>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3" data-id="element-1364" data-mp="2r1ruphoey0jx">
          <button className={`flex flex-col items-center gap-2 p-3 rounded-xl backdrop-blur-xl border transition-all ${isLight ? 'bg-white/80 border-slate-200 hover:bg-white shadow-sm' : 'bg-dark-card/60 border-white/10 hover:bg-white/5'}`} data-id="element-1365" data-mp="2qzx8m01eo2e9">
            <Phone className={`w-5 h-5 ${isLight ? 'text-vexu-600' : 'text-white'}`} data-id="element-1366" data-mp="35pl4umuqcav4" />
            <span className={`text-xs font-medium ${isLight ? 'text-slate-700' : 'text-zinc-300'}`} data-id="element-1367" data-mp="39tatfcbemsg5">
              Call
            </span>
          </button>
          <button className={`flex flex-col items-center gap-2 p-3 rounded-xl backdrop-blur-xl border transition-all ${isLight ? 'bg-white/80 border-slate-200 hover:bg-white shadow-sm' : 'bg-dark-card/60 border-white/10 hover:bg-white/5'}`} data-id="element-1368" data-mp="1ffrz0bco7pz2">
            <Shield className={`w-5 h-5 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-1369" data-mp="182tv8o7cwmpu" />
            <span className={`text-xs font-medium ${isLight ? 'text-slate-700' : 'text-zinc-300'}`} data-id="element-1370" data-mp="135agzoans9xw">
              Block
            </span>
          </button>
          <button className={`flex flex-col items-center gap-2 p-3 rounded-xl backdrop-blur-xl border transition-all ${isLight ? 'bg-white/80 border-slate-200 hover:bg-white shadow-sm' : 'bg-dark-card/60 border-white/10 hover:bg-white/5'}`} data-id="element-1371" data-mp="1vtg1qb1ppyxq">
            <UserPlus className={`w-5 h-5 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-1372" data-mp="1lwl7438k8ioq" />
            <span className={`text-xs font-medium ${isLight ? 'text-slate-700' : 'text-zinc-300'}`} data-id="element-1373" data-mp="afbp7l52xypj">
              Contact
            </span>
          </button>
        </div>

        <AISummaryCard summary="Missed call. AI answered and took a message. Caller wants to reschedule meeting to Tuesday." data-id="element-1374" data-mp="1uaxxb48t94bi" />

        <div className={`backdrop-blur-xl border rounded-2xl p-4 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/60 shadow-sm' : 'bg-dark-card/60 border-white/10 shadow-lg'}`} data-id="element-1375" data-mp="1z2fxhq30f0vf">
          <h3 className={`text-xs font-bold uppercase tracking-wider mb-3 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-1376" data-mp="1pc4m5igzxpei">
            Recording
          </h3>
          <AudioPlayer duration="0:45" data-id="element-1377" data-mp="2hyxpm8lrt2s7" />
        </div>

        <div data-id="element-1378" data-mp="240r9a6cv7lga">
          <h3 className={`text-xs font-bold uppercase tracking-wider mb-3 ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-1379" data-mp="2410px3c0sg9b">
            Transcript
          </h3>
          <div className={`backdrop-blur-xl border rounded-2xl p-4 text-sm leading-relaxed space-y-4 transition-colors duration-500 ${isLight ? 'bg-white/80 border-slate-200/60 text-slate-700 shadow-sm' : 'bg-dark-card/60 border-white/10 text-zinc-300 shadow-lg'}`} data-id="element-1380" data-mp="slkdhx7f2agj">
            <p data-id="element-1381" data-mp="k4bpu12inlzi">
              <span className={`font-bold ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-1382" data-mp="k4tkwudfzu5u">
                AI:
              </span>{' '}
              Hi, you've reached Alex's AI assistant. Alex is currently
              unavailable. How can I help you?
            </p>
            <p data-id="element-1383" data-mp="6cdpofqs90fh">
              <span className={`font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-1384" data-mp="6dyju496qhct">
                Sarah:
              </span>{' '}
              Hi, this is Sarah. I wanted to see if we could reschedule our
              meeting to next Tuesday?
            </p>
            <p data-id="element-1385" data-mp="bayp4cy7ng2v">
              <span className={`font-bold ${isLight ? 'text-vexu-600' : 'text-vexu'}`} data-id="element-1386" data-mp="baf6sv4nepob">
                AI:
              </span>{' '}
              I can pass that message along. Is there a specific time that works
              best for you?
            </p>
            <p data-id="element-1387" data-mp="8aorktgs2o7y">
              <span className={`font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-1388" data-mp="8aygseu00rcl">
                Sarah:
              </span>{' '}
              Anytime in the morning works. Please have Alex call me back before
              3 PM if possible.
            </p>
          </div>
        </div>
      </div>
    </div>;
}